
import weekmenu from '~/graphql/queries/weekmenu';
import upsertWeekmenu from '~/graphql/mutations/upsertWeekmenu';

export default {
  apollo: {
    weekmenu: {
      query: weekmenu,
      variables() {
        return {
          week: this.week,
          year: this.year,
        };
      },
    },
  },
  props: {
    recipeId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    days: [],
    weekNrs: [],
  }),
  computed: {
    week() {
      return this.weekNrs[0] && this.weekNrs[0].week;
    },
    year() {
      return this.weekNrs[0] && this.weekNrs[0].year;
    },
    unavailable() {
      if (!this.weekmenu) {
        return [];
      }

      return this.weekmenu.map(menu => parseInt(menu.weekday));
    },
  },
  watch: {
    weekNrs() {
      this.days = [];
    },
  },
  methods: {
    async save() {
      this.loading = true;

      try {
        const recipeIds = this.weekmenu.map(menu => menu.recept.id);

        this.days.forEach((day) => {
          recipeIds[day] = this.recipeId;
        });

        await this.$apollo.mutate({
          mutation: upsertWeekmenu,
          variables: {
            weeks: this.weekNrs,
            recipes: recipeIds,
          },
          refetchQueries: this.weekNrs.map(week => ({
            query: weekmenu,
            variables: week,
          })),
        });

        this.$toast.success('Uw weekmenu is succesvol opgeslagen.');
        this.$router.push({name: 'menu', params: {week: this.weekNrs[0]}});
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
